enum AppMode {
  Standard = "standard",
  Terminal = "terminal",
  Screen = "screen",
}

export default AppMode
